import { HasId } from '../interfaces';

export class PVAKeyValue implements HasId {
    public id: number;
    public key: string;
    public value: string;
    public organizationID?: number;
    public tenantID?: number;
}


// WEBPACK FOOTER //
// ./src/models/PVAKeyValue.tsx